import { render, staticRenderFns } from "./BottomBar.vue?vue&type=template&id=60254d7a&scoped=true&"
import script from "./BottomBar.vue?vue&type=script&lang=js&"
export * from "./BottomBar.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./BottomBar.vue?vue&type=style&index=0&id=60254d7a&scoped=true&lang=less&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "60254d7a",
  null
  ,true
)

export default component.exports